
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';

interface DateTimeSelectorProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  startTime: string;
  setStartTime: (time: string) => void;
  duration: number;
  setDuration: (duration: number) => void;
}

export const DateTimeSelector = ({
  date,
  setDate,
  startTime,
  setStartTime,
  duration,
  setDuration
}: DateTimeSelectorProps) => {
  return (
    <div className="flex-1 space-y-4">
      <div className="space-y-2">
        <Label>Select Date</Label>
        <div className="grid gap-2">
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="outline" className="w-full justify-start text-left font-normal">
                <CalendarIcon className="mr-2 h-4 w-4" />
                {date ? format(date, 'PPP') : <span>Pick a date</span>}
              </Button>
            </DialogTrigger>
            <DialogContent className="p-0">
              <Calendar mode="single" selected={date} onSelect={setDate} initialFocus />
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="startTime">Start Time</Label>
        <Input
          id="startTime"
          type="time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="duration">Duration (hours)</Label>
        <Input
          id="duration"
          type="number"
          min="0.5"
          step="0.5"
          max="24"
          value={duration}
          onChange={(e) => setDuration(parseFloat(e.target.value))}
        />
      </div>
    </div>
  );
};
